import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Compune clase Tailwind, cu ultima câştigătoare pe conflicte.
 *
 * `clsx` rezolvă condiţionalele, `twMerge` rezolvă conflictele (`p-2 p-4` → `p-4`) — fără
 * el, ordinea din CSS-ul generat ar decide, nu ordinea din apel.
 *
 * Fişierul vine din shadcn-admin, care mai aduce aici `sleep`, `getPageNumbers` şi
 * `getDisplayNameInitials`. N-au niciun consumator la noi, deci n-au fost păstrate.
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
